import React from 'react'
import { Image, Transformation, CloudinaryContext } from 'cloudinary-react'
const ShowImage = props => {
  let {
    publicID,
    format = 'png',
    crop,
    gravity,
    width,
    height,
    radius,
    style = {}
  } = props

  // triggers avatar
  publicID = publicID === '' ? 'publicID' : publicID

  return (
    <CloudinaryContext cloudName="safeshowings" style={style}>
      <Image
        publicId={publicID}
        format={format}
        style={{ borderRadius: '4px' }}
      >
        <Transformation
          crop={crop}
          gravity={gravity}
          width={width}
          height={height}
          radius={radius}
          defaultImage={`nopic0${5}.png`}
        />
      </Image>
    </CloudinaryContext>
  )
}

export default ShowImage
